import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type DateTimeInputProps, DateTimeInput } from '../DateTimeInput';

type FormDateTimeInputProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  DateTimeInputProps;

function FormDateTimeInput<TFieldValues extends FieldValues = FieldValues>(
  props: FormDateTimeInputProps<TFieldValues>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <DateTimeInput
      {...props}
      {...field}
      error={!!error}
      helperText={error?.message ?? props.helperText ?? undefined}
      required={!!props.rules?.required}
      ref={ref}
    />
  );
}

export type { FormDateTimeInputProps };
export { FormDateTimeInput };
